/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export enum CommunityCategoryBundle {
    FESTIVAL = 'Festival',
    CLUB = 'Club',
    CONVENTION = 'Convention',
}
